<template>
<div
  id="inbox"
  class="page page-on-center close-picker rowBackgroundHomepage"
  data-page="inbox-page" @ptr:refresh="refreshDocumentDetails(false)">

  <div class="showSmallScreenOnly blackBottomButton">
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank"
            @click="extractCSV(documentsList)">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
  </div>
  <div class="page-content infinite-scroll"
    style="z-index:9">
    <div class="listPage">
      <div class="row showLargeScreenOnly">
        <div class="row rowSearchBar">
          <back-button class="firstBlock"></back-button>
          <button class="milkyBlockBlack new-button-white firstBlock pull-right"
                  @click="extractCSV(documentsList)">
            <f7-icon f7="document_text"></f7-icon>
            <span class="fab-label">{{ $t('common.extract_csv') }}</span>
          </button>
          <button class="milkyBlockBlack firstBlock new-button-white"
                  @click="refreshDocumentDetails()">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">
              {{ $t('common.rfrsh') }}
            </span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="searchForm col-md-12">
          <div class="requestsList">
            <cm-messages-filter
              class="researchfilter"
              style="position:relative;z-index:10"
              :isPayments="true"
              :received="true"
              :listMainTitle="currentFolder[0].reference"
              :filterType="'details'"
              @applyFilter="applyFilter($event)">
            </cm-messages-filter>
            <f7-accordion-item class="accordionForm" :expanded="true">
              <f7-accordion-toggle class="accordionToggle">
                <transactions-list
                  :filterBy="false"
                  v-bind:messages="currentFolder"
                  :serviceId="serviceId"
                  style="border-radius: 0;">
                </transactions-list>
              </f7-accordion-toggle>
              <f7-accordion-content>
                <spinner v-if="activateSpinner"></spinner>
                <documents-list v-else-if="detailsDone"
                  :filterBy="false"
                  v-bind:documents="documentsList"
                  @get-folder-info="getFolderInfo()">
                </documents-list>
              </f7-accordion-content>
            </f7-accordion-item>
          </div>
        </div>
      </div>
      <div class="row justify-content-start">
        <div class="col-md-3 offset-md-9">
          <button round v-if="currentFolder[0].status !== '31'"
            class="button-action milkyBlockBlack"
            @click="updateFolderStatus('31')">
            <i class="icon fa fa-check"></i>
            {{ $t('businessDocuments.close_doc_group') }}
          </button>
          <button round v-else
            class="button-action milkyBlockBlack"
            @click="updateFolderStatus('30')">
            <i class="icon fa fa-exclamation-circle"></i>
            {{ $t('businessDocuments.reopen_doc_group') }}
          </button>
        </div>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import BusinessDocumentList from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue'
import documentSerialize from '@/helpers/documentSerialize.json'
import {errorMessageAlert} from '@/helpers/alert'
import {reloadPage} from '@/helpers/routing'
import MessagesFilter from '@/components/common/Filter'
import moment from 'moment'
import Spinner from '@/components/common/spinner.vue'
import {statusLabel} from '@/helpers/labels'
import TransactionsList from '@/pages/requests/TransactionsList.vue'

export default {
  name: 'businessDocumentDetailPage',
  components: {
    'back-button': backButton,
    'cm-messages-filter': MessagesFilter,
    'documents-list': BusinessDocumentList,
    'spinner': Spinner,
    'transactions-list': TransactionsList
  },
  data () {
    return {
      activateSpinner: true,
      currentFolder: [],
      detailsDone: false,
      documentsList: [],
      serviceId: this.$engine.user.currentService.id.toString()
    }
  },
  created () {
    this.currentFolder.push(this.$engine.services.businessDocuments.currentSendbox)
    this.getFolderDetails()
  },
  methods: {
    applyFilter (filterConditions) {
      if (filterConditions.documentStatus) {
        filterConditions.documentStatus = JSON.stringify(filterConditions.documentStatus)
      }
      this.detailsDone = false
      this.activateSpinner = true
      this.getFolderInfo()
      this.getFolderDetails(filterConditions)
    },
    createSupplier () {
      if (!this.validateForm()) {
        this.$f7.alert(this.$i18n.t('errors.errors_in_form_details'), this.$i18n.t('errors.errors_in_form'))
        return
      }
      this.$f7.showPreloader(this.$i18n.t('loading.adding_supplier'))
      let that = this

      that.$engine.services.suppliers.create({
        SellerIdentifier: this.sellerIdentifier,
        SocialReason: this.socialReason,
        Name: this.name,
        LegalRepresentativeLastName: this.name,
        LegalRepresentativeFirstName: this.firstname,
        LegalForm: this.legalStatus,
        Siren: this.siren,
        Siret: this.siret,
        Email: this.emailAddress,
        StreetName: this.streetName,
        PostalCode: this.zipCode,
        TownName: this.townName,
        ControlsMode: this.controlsConfig,
        CreateAccount: 0
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200 || response.status === 201) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: that.$i18n.t('success.supplier_added'),
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            reloadPage(that, {url: '/inbox/', force: true, ignoreCache: true})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    extractCSV (docList) {
      let lines = this.$t('businessDocuments.emission_reception_date') + ';' +
        this.$t('businessDocuments.request_name') + ';' +
        this.$t('businessDocuments.document_type') + ';' +
        this.$t('common.status.status_label') + ';' +
        this.$t('common.recipient_name') + '\r\n'

      for (let doc in docList) {
        lines += docList[doc]['date'] + ';' +
        docList[doc]['name'] + ';' +
        this.$i18n.t(documentSerialize[docList[doc]['type']].label) + ';' +
        statusLabel(this.$i18n, 'Doc_' + docList[doc]['status']) + ';' +
        docList[doc].correspondent + '\r\n'
      }
      const linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(lines)
      const downloadLink = document.createElement('a')
      let today = moment()
      const fileName = this.currentFolder[0].reference + '_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    getDocumentsDetails () {
      let that = this
      let nbDone = 0
      if (this.documentsList.length === 0) {
        that.activateSpinner = false
        that.detailsDone = true
      } else {
        for (var i = 0; i < this.documentsList.length; i++) {
          this.$engine.services.businessDocuments.getDocumentDetails(
            this.documentsList[i].IdDocument
          )
          .then(resp => {
            that.documentsList[that.documentsList.map(function (e) { return e.IdDocument }).indexOf(resp.data.IdDocument)] = resp.data
            nbDone++
            if (nbDone === that.documentsList.length) {
              that.activateSpinner = false
              that.detailsDone = true
            }
          })
          .catch(error => {
            errorMessageAlert(error, that, that.$i18n)
          })
        }
      }
    },
    getFolderDetails (filterConditions = {}) {
      let that = this
      this.$engine.services.businessDocuments.getDetails(
        this.currentFolder[0].idgroup,
        filterConditions
      )
      .then(resp => {
        that.documentsList = resp.data.Documents
        that.getDocumentsDetails()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getFolderInfo () {
      let that = this
      this.$engine.services['businessDocuments'].update(
        '',
        1000,
        1,
        this.$engine.services['businessDocuments'].filter.getConditionObject()
      ).then(resp => {
        let groups = resp.data.groups
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].idgroup === that.$engine.services.businessDocuments.currentSendbox.idgroup) {
            that.$engine.services.businessDocuments.currentSendbox = groups[i]
            that.currentFolder = []
            that.currentFolder.push(that.$engine.services.businessDocuments.currentSendbox)
            break
          }
        }
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    refreshDocumentDetails: function (noAttach = false, index = 1) {
      this.detailsDone = false
      this.activateSpinner = true
      this.getFolderInfo()
      this.getFolderDetails()
    },
    updateFolderStatus (newFolderStatus) {
      let that = this
      that.$engine.services.businessDocuments.updateFolderStatus({
        GroupId: this.currentFolder[0].idgroup,
        GroupStatus: newFolderStatus
      }).then(response => {
        if (response.status === 200) {
          that.$f7.modal({
            title: this.$t('businessDocuments.updated_folder'),
            text: '<span class="preloader"></span>'
          })
          that.currentFolder[0].status = newFolderStatus
          setTimeout(function () {
            that.$f7.closeModal()
          }, 1000)
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// BusinessDocumentDetailPage.vue?002a750e